import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <AppSection />
        <TopicsSection />
        <CarouselSection />
        <AboutSection />
        <RankingSection />
        <FaqSection />
        <FeaturesSection />
        <MediaSection />
        <CardsSection />
        <ContactSection />
        <CommentsSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}